import Yup from '@fourthwall/utils/dist/yup'

import type { FormValues } from './GiftCard.types'

export const validationSchema = Yup.object().shape({
  code: Yup.string().when('type', {
    is: (type: FormValues['type']) => type === 'SINGLE',
    then: Yup.string()
      .required()
      .min(8, '"${value}" code must have more than 8 characters.')
      .max(32, '"${value}" code must have less than 32 characters.')
      .matches(
        /^[A-Za-z0-9_-]+$/,
        "This field may only contain letters, numbers, '-' and '_' characters.",
      ),
  }),
  codes: Yup.array()
    .of(Yup.string())
    .when('type', {
      is: (type: FormValues['type']) => type === 'MULTIPLE',
      then: Yup.array()
        .min(1, 'This field is required.')
        .of(
          Yup.string()
            .min(8, '"${value}" code must have more than 8 characters.')
            .max(32, '"${value}" code must have less than 32 characters.')
            .matches(
              /^[A-Za-z0-9_-]+$/,
              "\"${value}\" code may only contain letters, numbers, '-' and '_' characters.",
            )
            .test(
              'unique',
              '"${value}" code can’t be added multiple times.',
              (value, context) =>
                !(context.parent.filter((item: any) => item === value).length > 1),
            ),
        )
        .required(),
    }),
  amount: Yup.number()
    .required('This field is required.')
    .max(2000, 'Amount must be less than 2000.'),
})
